if (typeof window !== "undefined" && typeof window.process === "undefined") {
  window.process = {
    env: {},
  };
}
